import {NodeSpec} from 'prosemirror-model';

/*
*
* display attr like in images
small
normal
large
* */

export const embed: NodeSpec = {
    group: 'block',
    attrs: {
        guid: {default: null},
        link: {default: ''},
        display: {default: 'normal'}
    },
    parseDOM: [{
        tag: 'div[data-node="embed"]',
        getAttrs: (element: HTMLElement) => {
            return ({
                guid: element.getAttribute('data-guid') as string,
                link: element.getAttribute("data-link"),
                display: element.getAttribute('data-display') as string,
            })
        }
    },],
    selectable: true,
    draggable: true,
    toDOM(node) {
        const {guid, link, display} = node.attrs;
        return ["div", {
            target: "_self",
            "class": `pm-embed`,
            "data-node": "mention",
            "data-guid": guid,
            "data-link": link,
            "data-display": display,
        }]
    },
    dragHandle: true,
}
